import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, tap, throwError } from 'rxjs';

import { UserStore } from '@core/stores';

type TErrorGQLResponse = { message: string; status: string };

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  const token = userStore.token();

  if (!token) {
    return next(req);
  }

  const clonedRequest = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(clonedRequest).pipe(
    tap((resp: HttpResponse<{ errors: TErrorGQLResponse[] }>) => {
      const errors = resp?.body?.errors;

      if (Array.isArray(errors)) {
        const isUnAuth = resp?.body?.errors?.some(
          (error) =>
            error?.status === 'UNAUTHENTICATED' &&
            error?.message === 'Expired token',
        );

        if (isUnAuth && userStore.token()) {
          throw new Error('EXPIRED');
        }
      }
    }),
    catchError((err) => {
      if (
        err?.message === 'EXPIRED' ||
        err?.error?.message === 'Expired token'
      ) {
        void userStore.onClear();
        void router.navigate(['/login'], { replaceUrl: true });
      }

      return throwError(() => new Error(err?.error?.message || err?.message));
    }),
  );
};
